import {
  safeGetStorageItem,
  safeRemoveStorageItem,
  safeSetStorageItem,
} from "./safeStorage";

export const STORAGE_VERSION_KEY = "webdispatcher_storage_version";
export const CURRENT_STORAGE_VERSION = "2026-06-24-pak-stability-1";

const RISKY_LOCAL_STORAGE_KEYS = [
  "webdispatcher.eventPulseUntil",
  "webdispatcher.pinnedEventChat",
  "webdispatcher.unitClusteringEnabled",
  "unit_click_3v1",
  "unitsNotify",
  "unitsNotifySms",
  "unitsNotifyPush",
  "unitsNotifyCall",
  "soundNotificationsEnabled",
];

const RISKY_LOCAL_STORAGE_PREFIXES = [
  "lastReadMessages_",
  "lastReadPatients_",
  "event_",
];

const RISKY_SESSION_STORAGE_KEYS = [
  "preferredScenarioTaskId",
];

export const clearRiskyWebDispatcherStorage = (reason = "manual cleanup") => {
  if (typeof window === "undefined") return;

  console.warn(`[WD storage] cleanup: ${reason}`);

  RISKY_LOCAL_STORAGE_KEYS.forEach((key) =>
    safeRemoveStorageItem(key, { reason }),
  );

  try {
    Object.keys(window.localStorage || {}).forEach((key) => {
      if (RISKY_LOCAL_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        safeRemoveStorageItem(key, { reason });
      }
    });
  } catch (error) {
    console.warn("[WD storage] nepodařilo se projít localStorage při cleanupu", error);
  }

  RISKY_SESSION_STORAGE_KEYS.forEach((key) =>
    safeRemoveStorageItem(key, { storageName: "sessionStorage", reason }),
  );
};

export const migrateWebDispatcherStorage = () => {
  const currentVersion = safeGetStorageItem(STORAGE_VERSION_KEY);
  if (currentVersion === CURRENT_STORAGE_VERSION) return;

  console.warn(
    `[WD storage] storage version mismatch: ${currentVersion || "none"} -> ${CURRENT_STORAGE_VERSION}`,
  );
  clearRiskyWebDispatcherStorage("storage version mismatch");
  safeSetStorageItem(STORAGE_VERSION_KEY, CURRENT_STORAGE_VERSION);
};

export const clearTransientRouteStateFromUrl = (reason = "transient route cleanup") => {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search);
  const before = params.toString();
  ["event", "eventID", "eventId", "detail", "unit", "unitID", "unitId", "base", "baseID", "baseId", "focus", "route", "tracking"].forEach((key) =>
    params.delete(key),
  );

  const after = params.toString();
  if (before === after) return;

  console.warn(`[WD router] cleaned stale transient query (${reason})`);
  const nextUrl = `${window.location.pathname}${after ? `?${after}` : ""}${window.location.hash || ""}`;
  window.history.replaceState(null, "", nextUrl);
};
